<template>
    <v-layout class="fill-height px-3 flex-column" >
        <div class="my-3 scan-header">AUDIT SCREENSHOTS</div>
        <v-row  align="baseline">
            <v-col cols="12" md="4">
                <v-combobox
                    :value="getSelectedWebsite"
                    :items="getWebsites"
                    placeholder="Choose the website"
                    item-text="name"
                    item-value="id"
                    dense
                    outlined
                    solo
                    @change="selectWebsite"
                />
            </v-col>
            <v-col cols="12" md="4">
                <Datepicker
                        :selectedDate="getSelectedDate"
                        v-on:onChange="selectDate"
                        v-if="getSelectedWebsite"
                        :allowDates="getDates"
                        checkDaysDiff
                />
            </v-col>
            <v-col cols="12" md="12">
                <v-row class="mt-1">
                    <v-col cols="12" md="4" v-for="(screenshots, screenshotDate) in getScreenshots" :key="screenshotDate">
                        <div>{{screenshotDate}}</div>
                        <div v-for="(screenshotUrl, index) in screenshots" :key="index">
                            <img v-bind:src="screenshotUrl" alt="" style="max-width:100%; cursor:pointer;" @click="openModal(screenshotUrl)">
                        </div>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-dialog
            v-model="dialog"
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
            scrollable
        >
            <v-card @click="closeModal">
                <v-layout class="container">
                <v-row>
                    <v-col cols="12">
                        <v-btn
                            icon
                            @click="dialog = false"
                        >
                            Close
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-col>
                    <v-col offset="1" cols="10">
                        <img v-bind:src="activeImage" alt="" style="max-width:100%; cursor:pointer;">
                    </v-col>
                </v-row>
                </v-layout>

            </v-card>
      </v-dialog>
    </v-layout>

</template>

<script>
    import { createNamespacedHelpers } from "vuex";
    import Datepicker from "../components/common/Datepicker"
    const authHelper = createNamespacedHelpers("auth");
    const screenshotsHelper = createNamespacedHelpers("screenshots");
    export default {
        name: "Screenshots",
        components: { Datepicker },
        data:function() {
            return {
                dialog: false,
                activeImage: null
            }
        },
        computed: {
            ...authHelper.mapGetters(["getSelectedClient", "isAdmin"]),
            ...screenshotsHelper.mapGetters(["getWebsites", "getDates", "getScreenshots", "getSelectedWebsite", "getSelectedDate"]),

        },
        methods: {
            ...screenshotsHelper.mapActions([
                "fetchClientWebsites",
                "fetchClientDates",
                "fetchClientScreenshots",
                "selectWebsite",
                "selectDate",
                "clearScreenshotsState",
                "clearScreenshotsDateState",
            ]),
            openModal(src) {
                this.activeImage = src;
                this.dialog = true;
            },
            closeModal() {
                this.activeImage = null;
                this.dialog = false;
            }
        },
        watch: {
            getSelectedClient: function() {
                //Place for reset screenshots store and refetch webstites for admin
                this.clearScreenshotsState();
                this.fetchClientWebsites(this.getSelectedClient)
            },
            getSelectedWebsite: function(website) {
                if (website) {
                    this.clearScreenshotsDateState();
                    this.fetchClientDates(this.getSelectedClient);
                }
            },
            getSelectedDate: function(date) {
                if (date && date.length) {
                    this.fetchClientScreenshots(this.getSelectedClient)
                }
            }
        },
        created() {
            this.fetchClientWebsites(this.getSelectedClient)
        }
    };
</script>
